export default __webpack_public_path__ + "static/media/Banner - Elevate Pro - White-1.819a96fc.jpg";